// extracted by mini-css-extract-plugin
export default {"titleWithDescription":"TitleWithDescription_titleWithDescription__l7Vb9","title":"TitleWithDescription_title__7HCKs","subtitle":"TitleWithDescription_subtitle__EgaRb"};